import { createContext, useContext, useState } from "react";
import { Contract } from "ethers";
import IERC20 from "../abis/IERC20.json";

const DataContext = createContext();

export const DataContextProvider = ({ children }) => {
  const decimals = 10 ** 18;
  const initialResultMsg = {
    msgType: 0, //1: error, 2: success
    urlTitle: null,
    url: null,
    msg: null,
  };
  const initialData = {
    poolId: 0,
    name: null,
    createDate: 0,
    joinDay: 0,
    lockDay: 0,
    totalPool: 0,
    oneTicketOfToken: 0,
    minTicketCount: 0,
    status: 0,
    lat: 32.938058,
    long: 21.714991,
    zoom: 3,
    distance: 30000000,
    callbackMaxTicket: 0,
  };
  const initialGetInfo = {
    prizeShareCount: null,
    userTicketCount: null,
    userJoinedPoolCount: null,
    ticketCount: null,
    assignTicketCount: null,
    refCodesCount: null,
    prizeSeedsCount: null,
    maxTicketCount: null,
  };

  const [reRender, setReRender] = useState(false);
  const [poolData, setPoolData] = useState(initialData);
  const [showPoolDetail, setShowPoolDetail] = useState(false);
  const [toastArgs, setToastArgs] = useState({
    header: null,
    messageType: null,
    message: null,
    isShow: false,
  });

  const updatePoolData = (newPoolData) => {
    setPoolData(newPoolData);
  };

  const togglePoolData = () => {
    setShowPoolDetail((prevShowPoolDetail) => !prevShowPoolDetail);
  };

  const openData = () => {
    setShowPoolDetail(true);
  };

  const closeData = () => {
    setShowPoolDetail(false);
  };

  const statusText = (status) => {
    switch (status) {
      default:
        return "Invalid";
      case 1:
        return "Coming Soon";
      case 2:
        return "Join";
      case 3:
        return "Locked";
      case 4:
        return "Raffle";
      case 5:
        return "Claim";
      case 6:
        return "Ended";
      case 7:
        return "Refund";
    }
  };

  const getToken = async (signerVars, unSignerVars, tokenAddress, userAddress) => {
    if (!tokenAddress) return null;
    const contract = new Contract(
      tokenAddress,
      IERC20.abi,
      userAddress ? signerVars.signer : unSignerVars.provider
    );
    const symbol = await contract.symbol();
    const name = await contract.name();
    const decimals = await contract.decimals();
    const balance = userAddress ? await contract.balanceOf(userAddress) : null;
    const allowanceAmount = userAddress
      ? Number(
          await contract.allowance(
            userAddress,
            process.env.REACT_APP_CONTRACT_ADDRESS
          )
        )
      : null;

    return { contract, symbol, name, decimals, balance, allowanceAmount };
  };

  return (
    <DataContext.Provider
      value={{
        decimals,
        initialResultMsg,
        initialData,
        initialGetInfo,
        reRender,
        poolData,
        showPoolDetail,
        toastArgs,
        setReRender,
        updatePoolData,
        togglePoolData,
        openData,
        closeData,
        statusText,
        setToastArgs,
        getToken
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useData must be used within a "DataContextProvider"');
  }
  return context;
};
